import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import App from './app.component';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import portalApp from './reducers';
import registerServiceWorker from './registerServiceWorker';
import WebFont from 'webfontloader';
import Interceptor from './services/Interceptor';

WebFont.load({
    google: {
        families: ['Barlow:300,400,400i,500,600,700'],
    },
});

const store = createStore(portalApp);
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
    <Provider store={store}>
        <Suspense fallback={null}>
            <Router>
                <App />
            </Router>
        </Suspense>
    </Provider>,
);

registerServiceWorker();
Interceptor.setupInterceptors();
